import { render, staticRenderFns } from "./questionsnav.vue?vue&type=template&id=4c503651&"
import script from "./questionsnav.vue?vue&type=script&lang=js&"
export * from "./questionsnav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports